<template>
  <div>
    <h2>Login</h2>
    <form @submit.prevent="handleSubmit" class="form-group">
      <div class="row justify-content-md-center">
        <div class="col-sm-3">
          <label>Username:</label>
        </div>
        <div class="col-sm-4">
          <input class="form-control" required v-model="$v.username.$model">
        </div>
        <b-alert :show="$v.username.$dirty && !$v.username.required">Required</b-alert>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-3">
          <label>Password:</label>
        </div>
        <div class="col-sm-4">
          <input
            id="txtPassword"
            class="form-control"
            required
            type="password"
            v-model="$v.password.$model"
          >
          <b-alert :show="$v.password.$dirty && !$v.password.required">Required</b-alert>
        </div>
      </div>

      <label>
        <input
          type="checkbox"
          class="option-input checkbox"
          v-model="checked"
          true-value="yes"
          false-value="no"
        >
        Show Password
      </label>
      <div v-show="InvalidLogin" style="color: red;">
        The username or password is incorrect
      </div>

      <div class="row justify-content-md-center">
        <button class="btn btn-primary btn-lg">Login</button>
      </div>
    </form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { userService } from "@/resources/UserService.js";
import { mapGetters, mapActions } from 'vuex';
//import { EventBus } from "@/components/event-bus.js";

export default {
  name: "Login",
  data: () => ({
    username: "",
    password: "",
    checked: "no",
    returnUrl: null,
    response: null,
    InvalidLogin: false
  }),
  validations: {
    username: {
      required
    },
    password: {
      required
    }
  },
  methods: {
    ...mapActions('account', ['logout', 'login','forgotPassword']),
    // async login() {
    //   try {
    //     await this.axios.post("/auth/login", {
    //       username: this.username,
    //       password: this.password
    //     });
    //     localStorage.setItem(
    //       "user",
    //       JSON.stringify(window.btoa(`${this.username}:${this.password}`))
    //     );
    //     this.$router.push({
    //       name: "surveyMenu"
    //     });
    //   } catch (err) {
    //     console.error(err);
    //   }
    // },
    async handleSubmit() {
      try {
        this.InvalidLogin = false;
        this.returnUrl = this.$route.query.returnUrl || "/";
        console.log(this.returnUrl);
        this.response = await this.login({username: this.username, password: this.password});
        
        if (this.response) {
          //EventBus.$emit('loggedIn', true);
          this.$router.push(this.returnUrl);
        }
        else {
            this.InvalidLogin = true;
        }
      } catch (err) {
        this.InvalidLogin = true;
        this.password = "";
        //EventBus.$emit('loggedIn', false);
        console.error("error",err);
      }
    }
  },
  watch: {
    checked() {
      let inputPwd = document.getElementById("txtPassword");
      if (this.checked === "yes") inputPwd.type = "text";
      else inputPwd.type = "password";
    }
  }
};
</script>

<style scoped>
.row {
  padding-top: 2%;
}
</style>
